import ChartActionId from '@/common/enums/chart-action-id.enum';
import ChartGroupActionType from '@/common/enums/chart-group-action-type.enum';
import ChartAction from '@/common/models/chart/ChartAction';

export default class ChartGroupAction {
  id: ChartActionId | null;
  type: ChartGroupActionType | null;
  label: string;
  rank: number;
  options: ChartAction[];
  isHighlighted: boolean;
  isSelectable: boolean;
  transform: (list: number[], key?: string) => number | null;

  constructor(
    id?: ChartActionId,
    type?: ChartGroupActionType,
    label = '',
    rank = 0,
    options = [],
    isHighlighted = false,
    isSelectable = true,
    transform = null,
  ) {
    this.id = id;
    this.type = type;
    this.label = label;
    this.rank = rank;
    this.options = options;
    this.isHighlighted = isHighlighted;
    this.isSelectable = isSelectable;
    this.transform = transform;
  }
}
